// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBkLKN-VfNEKg-wCEiw5YY-Z7QXtmb9JX4",
  authDomain: "barzelbank.firebaseapp.com",
  projectId: "barzelbank",
  storageBucket: "barzelbank.firebasestorage.app",
  messagingSenderId: "927112403351",
  appId: "1:927112403351:web:caed03c37574cddda50cd2",
  measurementId: "G-10FNKPXWPX",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const auth = getAuth();
const analytics = getAnalytics(app);

export { app, storage, auth, analytics, onAuthStateChanged, signOut };
